import { useDialogStore } from '~/stores/dialog.ts';

export default defineNuxtRouteMiddleware(() => {
  const dialogStore = useDialogStore();
  if (dialogStore.componentName) {
    dialogStore.showDialog = false;
  }
});
